import { render, staticRenderFns } from "./ScrmCustomerOrder.vue?vue&type=template&id=ea990f1a&scoped=true"
import script from "./ScrmCustomerOrder.vue?vue&type=script&lang=js"
export * from "./ScrmCustomerOrder.vue?vue&type=script&lang=js"
import style0 from "./ScrmCustomerOrder.vue?vue&type=style&index=0&id=ea990f1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea990f1a",
  null
  
)

export default component.exports